export default (galleryState) => {
  const { searchProfile, searchParameters, availableSearchParameters } =
    galleryState;
  const newSearchParameters = {};
  const preservedParams = [
    'assettype',
    'editorialproducts',
    'family',
    'mediatype',
    'phrase',
    'premiumaccess',
    'easyaccess',
    'editorialsubscription',
    'royaltyfreesubscription',
    'excludenudity',
    'phraseprocessing',
  ];
  const preservedParamsGetty = ['alloweduse', 'subPreview', 'subPreviewSku'];
  const preservedParamsIstock = searchProfile?.srpUpsellTestEligible
    ? ['istockcollection']
    : [];
  const siteSpecificPreservedParams =
    searchProfile.site.nickname === 'getty'
      ? preservedParams.concat(preservedParamsGetty)
      : preservedParams.concat(preservedParamsIstock);

  for (const preservedParam of siteSpecificPreservedParams) {
    if (
      availableSearchParameters[preservedParam] &&
      searchParameters[preservedParam] !== undefined
    ) {
      newSearchParameters[preservedParam] = searchParameters[preservedParam];
    }
  }
  return newSearchParameters;
};
